module.exports = __webpack_public_path__ + "img/cass3.1f419994.jpg";